import React from 'react';
import './Image.scss';
//import React, {useState} from "react";
const Image = ({ src, alt, size = "base", rounded = false, square = false, vertical = false, onClick, onContextMenu, filter }) => {
    let classImg = "image";
      
    return (React.createElement("img", { className: `${classImg} `, src: src, alt: alt }));
};

export { Image as default };